<template>
	<div class="register-container">
		<div class="register-form">
			<div class="inHead">
				<span style="font-weight: bold;">{{urlName|formatName}}</span>
				&nbsp;邀请您使用星报告
			</div>
			<el-form :model="registerForm" :rules="rules" ref="registerForm" label-width="80px">
				<el-form-item label-width="0" prop="username">
					<el-input v-model="registerForm.username" placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item label-width="0" prop="phone">
					<el-input v-model="registerForm.phone" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label-width="0" prop="password">
					<el-input v-model="registerForm.password" :type="showPassword ? 'text' : 'password'"
						placeholder="请设置密码">
						<i slot="suffix" :class="['el-input__icon', showPassword ? 'el-icon-view' : 'el-icon-view']"
							@click="showPassword = !showPassword" style="cursor: pointer"></i>
					</el-input>
				</el-form-item>
				<el-form-item label-width="0" prop="code">
					<el-input v-model="registerForm.code" placeholder="请输入验证码">
						<!-- <el-button slot="append" @click="getCode" :disabled="codeDisabled">{{ codeText }}</el-button> -->
						<span slot="append" @click="getYZM">
							<div class="tzmtup">
								<img :src="yzmUrl" alt="" />
							</div>
						</span>
					</el-input>
				</el-form-item>
				<div class="xyMain">
					<el-checkbox v-model="agreed" class="agreement-checkbox"> </el-checkbox>
					<div class="agreement-text">
						<span @click.stop="agreedFn"> 我已阅读并同意 </span>
						<span class="link-text" @click.stop="openXy(0)">《用户协议》</span>
						<!-- <span class="link-text" @click.stop="openXy(1)">《信息技术服务合同》</span>
            <span class="link-text" @click.stop="openXy(2)">《推广方管理制度》</span> -->
						<span @click.stop="agreedFn">
							点击勾选即代表您同意上述法律文书的相关条款并签署上述法律文书
						</span>
					</div>
				</div>
				<div class="">
					<el-button type="primary" @click="handleRegister" :loading="loading">注册</el-button>
				</div>

				<div style="margin-top: 10px;">
					<el-button type="danger" @click="handleTransferCustomer" :loading="loading">我已注册，跳转客服</el-button>
				</div>
			</el-form>
		</div>
		<el-drawer title="用户协议" :append-to-body="true" :visible.sync="drawer" size="100%" direction="btt">
			<div class="xyMainContent">
				<div>查询协议</div>
				<div>
					本授权协议是由本平台和您签订。如您选择点击同意此协议将视为授权本平台向第三方支付/征信/金融机构/提交您的个人信息，将视为您已阅读并理解本协议的全部内容。
				</div>
				<div>授权条款</div>
				<div>
					(一)您同意在您注册或使用本平台时，本平台依据相关法律法规向第三方支付/征信/金融机构或通过上述机构向其他拥有合法资质的第三方(包括但不限于具有资质的征信机构，运营商及其代理商、关联公司，公安部身份信息查询中心等)了解、获取、核实您的信用信息。并同意本平台及上述机构将查询获取的信息进行保存、整理、加工，并用于评价本人信用情况或核实本人信息的真实性。
				</div>
				<div>
					(二)您同意在您注册或使用本平台时，本平台将依据相关法律法规，向第三方支付/征信/金融机构提交您在本平台业务中产生的相关信息，包括个人基础信息、信用/提现信息、借款申请信息、借款合同信息以及还款信息等，并记录在上述机构建立的信息数据库中。
				</div>
				<div>
					(三)您在本平台打赏获取的分析报告，为本平台独家知识产权，其内容为本平台的著作权，仅供您个人24小时参考使用，过期将失效，相关个人信息均为您授权同意后交由本平台做分析用，请勿泄露给第三方。上述过程中，如造成个人信息泄露。由于本平台已经尽到提醒和防范义务，本平台故概不负责。
				</div>
				<div>二. 保密条款</div>
				<div>
					(一)本平台重视对用户隐私的保护。因收集您的信息是出于遵守国家法律法规以及向您提供服务及提升服务质量的目的，本平台对您的信用信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租您的任何信息。
				</div>
				<div>(二)本平台会在下列情况下才将您的个人信用信息与第三方共享:</div>
				<div>1、事先获得用户的明确授权;</div>
				<div>2、某些情况下只有共享您的信息才能提供您需要的服务或产品;</div>
				<div>
					3、某些服务或产品由本平台的合作伙伴提供或由本平台与合作伙伴共同提供，本平台会与其共享提供服务或产品需要的信息:
				</div>
				<div>4、为维护本平台和其他平台用户的合法权益:</div>
				<div>
					5、根据法律规定及合理商业习惯，在本平台计划与其他公司合并或被其收购或进行其他资本市场活动(包括但不限于IPO，债券发行)时，以及其他情形下本平台需要接受来自其他主体的尽职调查时，本平台会把您的信息提供给必要的主体，但本平台会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理的保密措施;
				</div>
				<div>6、按照相关政府主管部门的要求:</div>
				<div>
					7、由于用户将其注册密码告知他人或与他人共享账户密码，由此导致的任何个人信息泄露，或其他非本平台原因导致用户个人信息的泄露:
				</div>
				<div>
					8、任何由于黑客攻击、电脑病毒入侵及其他不可抗力事件所导致的用户信息泄露、公开:
				</div>
				<div>三、用户义务及免责声明</div>
				<div>
					(一)您保证所提供的个人信息均为您本人的真实信息，不可为他人的信息或虚假信息，若涉嫌恶意信息作假或盗用他人信息，将可能记入网络征信系统，影响您的征信记录，同时本平台将保留追究您相应法律责任的权利。
				</div>
				<div>
					(二)如您所提供的个人信息中全部或部分信息为他人信息或虚假信息，本平台将有权暂停或终止与您的全部或部分服务协议，由此行为所产生的全部法律责任将由您承担，本平台将不对此承担法律责任。
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import {
		generateCaptchaUrl
	} from "./generateCaptchaUrl";
	import {
		selfRegister
	} from "@/api/admin";

	export default {
		name: "Register",
		data() {
			const validateUsername = (rule, value, callback) => {
				if (value.length < 3) {
					callback(new Error("账号必须大于3位"));
				} else {
					callback();
				}
			};
			const validatePhone = (rule, value, callback) => {
				if (!value) {
					callback();
					return;
				}
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(value)) {
					callback(new Error("请输入有效的手机号"));
				} else {
					callback();
				}
			};
			const validatePassword = (rule, value, callback) => {
				if (value.length < 6) {
					callback(new Error("密码不能低于6位"));
				} else {
					callback();
				}
			};
			return {
				loading: false,
				showPassword: false,
				codeDisabled: false,
				codeText: "获取验证码",
				countDown: 60,
				timer: null,
				agreed: true,
				registerForm: {
					username: "",
					phone: "",
					password: "",
					code: "",
				},
				rules: {
					username: [{
							required: true,
							message: "请输入账号",
							trigger: "blur"
						},
						{
							validator: validateUsername,
							trigger: "blur"
						},
					],
					phone: [
						// { required: true, message: "请输入手机号", trigger: "blur" },
						{
							validator: validatePhone,
							trigger: "blur"
						},
					],
					password: [{
							required: true,
							message: "请设置密码",
							trigger: "blur"
						},
						{
							validator: validatePassword,
							trigger: "blur"
						},
					],
					code: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}],
				},
				yzmUrl: "",
				yzmCode: "",
				urlName: "",
				drawer: false,
			};
		},
		created() {
			this.urlName = this.$route.query.name;
			// this.registerForm.username = "666";
			// this.registerForm.password = "123456";
			console.log("this.urlName", this.urlName);
			this.getYZM();
		},
		filters: {
			formatName(phone) {
				if (!phone) return '';
				return `${phone.toString().slice(0, 1)}****${phone.toString().slice(-2)}`;
			}
		},
		methods: {
			agreedFn() {
				this.agreed = !this.agreed;
			},
			getYZM() {
				// // 生成4个随机字符（数字+大小写字母）

				// 生成验证码图片URL
				const randomCode = this.getRandomCode();
				const captchaUrl = generateCaptchaUrl(randomCode);
				// console.log("验证码字符：", randomCode);
				// console.log("验证码图片URL：", captchaUrl);
				this.yzmCode = randomCode;
				// this.registerForm.code = randomCode;

				this.yzmUrl = captchaUrl;
			},
			getRandomCode() {
				// const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
				const chars = "0123456789";
				let code = "";
				for (let i = 0; i < 4; i++) {
					code += chars[Math.floor(Math.random() * chars.length)];
				}
				return code;
			},
			handleTransferCustomer() {
				this.$router.push("/register-success");
			},
			handleRegister() {
				if (!this.agreed) {
					this.$message.error("请先阅读并同意《用户协议》");
					return;
				}
				if (!this.registerForm.code || this.registerForm.code != this.yzmCode) {
					this.$message.error(!this.registerForm.code ? "请输入验证码！" : "验证码错误！");
					return;
				}
				this.$refs.registerForm.validate((valid) => {
					if (valid) {
						this.loading = true;
						// 调用注册接口
						const registerData = {
							username: this.registerForm.username,
							password: this.registerForm.password,
							whetherSubAccount: 0,
							telephone: this.registerForm.phone,
							sourceType: 1,
							referrer: this.urlName,
							status: 0,
						};
						selfRegister(registerData)
							.then((res) => {
								this.loading = false;
								if (res.code === 200 || res.code === 0) {
									this.$message.success("注册成功！");
									this.$router.push("/register-success");
								} else {
									// this.$message.error(res.message || "注册失败，请重试");
								}
							})
							.catch((err) => {
								this.loading = false;
								console.error("注册失败:", err);
								// this.$message.error(err.message || "注册失败，请重试");
							});
					} else {
						return false;
					}
				});
			},
			goBack() {
				// this.$router.go(-1);
			},
			openXy(i) {
				console.log(i);
				this.drawer = true;
			},
		},
	};
</script>

<style scoped>
	.register-container {
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(180deg, #6aadfc, #d2e8fd);
		padding: 20px;
		background-image: url("../assets/rbk.png");
		background-size: 100% 100%;
		box-sizing: border-box;
	}

	@media (min-width: 768px) {
	  .register-form {
	  	background: white;
	  	padding: 16px;
	  	border-radius: 10px;
	  	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	  	position: absolute;
	  	bottom: 120px;
	  	width: calc(35% - 72px);
	  }
	}
	
	@media (max-width: 767px) {
	  .register-form {
	  	background: white;
	  	padding: 16px;
	  	border-radius: 10px;
	  	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	  	position: absolute;
	  	bottom: 50px;
	  	width: calc(100% - 72px);
	  }
	}

	.register-form h2 {
		text-align: center;
		/* margin-bottom: 30px; */
		color: #333;
	}

	.el-button {
		width: 100%;
		/* margin-bottom: 10px; */
	}

	.el-button:last-child {
		/* margin-bottom: 0; */
	}

	.tzmtup img {
		width: 100px;
		height: 100%;
	}

	:deep(.el-input-group__append) {
		width: 100px !important;
		padding: 0 !important;
	}

	.inHead {
		font-size: 14px;
		color: #999;
		text-align: center;
		padding-bottom: 16px;
	}

	.agreement-checkbox {
		margin-bottom: 16px;
		display: block;
	}

	.agreement-text {
		font-size: 12px;
		color: #999;
		word-wrap: break-word;
		word-break: break-all;
		white-space: normal;
		line-height: 1.5;
		padding-right: 16px;
	}

	.link-text {
		color: #a6a2dc;
		cursor: pointer;
		margin: 0 2px;
	}

	.agreement-checkbox {
		align-items: flex-start;
	}

	.xyMain {
		display: flex;
		padding-bottom: 16px;
	}

	.agreement-text {
		margin-left: 8px;
	}

	:deep(.el-drawer__header) {
		padding: 16px !important;
		margin-bottom: 0 !important;
	}

	.xyMainContent {
		padding: 0 16px 16px 16px;
	}
</style>